import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React, { useState, useRef } from 'react';
import { Modal, View } from 'react-native';
import { SccTouchableWithoutFeedback } from '@/components/SccTouchableWithoutFeedback';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
const PositionedModal = ({ children, modalContent, visible, onClose, }) => {
    const [showModal, setShowModal] = useState(false);
    const [childPosition, setChildPosition] = useState(null);
    const childRef = useRef(null);
    const measureChildPosition = () => {
        var _a;
        (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.measureInWindow((x, y, width, height) => {
            setChildPosition({ x, y, width, height });
            setShowModal(true);
        });
    };
    const handleClose = () => {
        setShowModal(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(SccTouchableWithoutFeedback, { elementName: "positioned_modal_trigger", onPress: measureChildPosition, children: _jsx(View, { ref: childRef, children: children }) }), _jsx(Modal, { visible: visible !== null && visible !== void 0 ? visible : showModal, transparent: true, animationType: "fade", statusBarTranslucent: true, onRequestClose: handleClose, children: _jsx(SccTouchableWithoutFeedback, { elementName: "positioned_modal_overlay", onPress: handleClose, children: _jsx(ModalOverlay, { children: childPosition && (_jsxs(ModalArea, { children: [_jsx(ModalTail, { style: {
                                        top: childPosition.y + childPosition.height + 5 + 5,
                                        left: childPosition.x + childPosition.width / 2 - 5,
                                    } }), _jsx(ModalContent, { style: {
                                        top: childPosition.y + childPosition.height + 5,
                                    }, children: modalContent })] })) }) }) })] }));
};
const ModalOverlay = styled.View `
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
`;
const ModalArea = styled.View `
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.25;
  shadow-radius: 3.84px;
  elevation: 3;
`;
const ModalContent = styled.View `
  background-color: ${color.brandColor};
  padding: 12px;
  margin-left: 32px;
  margin-right: 32px;
  border-radius: 8px;
`;
const ModalTail = styled.View `
  background-color: ${color.brandColor};
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
`;
export default PositionedModal;
